export const homeUrl = 'https://iprim.ru'
export const oauthUrl = 'https://passport.iprim.ru/oauth'
export const apiBaseUrl = 'https://passport.iprim.ru'
export const titlePostfix = ' - IPRIM.RU'
